import ActividadesRepository from "@/services/ActividadesRepository";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    listaTrabajo: [],
    listaTrabajoFicha: [],
  },
  getters: {
    getTrabajo: (state) => (idTrabajo) => {
      return state.listaTrabajoFicha.find(
        (trabajo) => trabajo.idTrabajoParcela === idTrabajo
      );
    },

    getListaTrabajoByTipoTrabajoList:
      (state) => (tipoTrabajoList, idFichaAgricola) => {
        return state.listaTrabajoFicha.filter((trabajo) => {
          return tipoTrabajoList.some((tipoTrabajo) => {
            return (
              trabajo.idTipoTrabajo === tipoTrabajo.idTipoTrabajo &&
              trabajo.idFichaAgricola === idFichaAgricola
            );
          });
        });
      },
  },
  mutations: {
    setListaTrabajo(state, listaTrabajo) {
      state.listaTrabajo = listaTrabajo.map((trabajo) => {
        trabajo.fechaFormated = Vue.filter("fhDate")(trabajo.fecha);
        trabajo.costoTotalFormated = Vue.filter("fhIntegerNumber")(
          trabajo.costoTotal
        );
        return trabajo;
      });
    },

    setListaTrabajoFicha(state, listaTrabajo) {
      state.listaTrabajoFicha = listaTrabajo.map((trabajo) => {
        trabajo.fechaFormated = Vue.filter("fhDate")(trabajo.fecha);
        trabajo.costoTotalFormated = Vue.filter("fhIntegerNumber")(
          trabajo.costoTotal
        );
        return trabajo;
      });
    },

    clearTrabajo(state) {
      state.listaTrabajo = [];
    },

    clearTrabajoFicha(state) {
      state.listaTrabajoFicha = [];
    },
  },
  actions: {
    async fetchListaTrabajo(
      { state, commit, rootState },
      [
        refetch = false,
        idFichasAgricola = [null],
        fechaDesde = null,
        fechaHasta = null,
      ]
    ) {
      if (!refetch && state.listaTrabajo && state.listaTrabajo.length > 0) {
        return;
      }

      let idEstablecimiento =
        rootState.establecimientos.establecimiento.idEstablecimiento;
      let idTemporada = rootState.temporada.temporada?.idTemporada;

      let listaTrabajo =
        (await ActividadesRepository.listaTrabajo(
          idEstablecimiento,
          idTemporada,
          idFichasAgricola,
          fechaDesde,
          fechaHasta
        )) || [];
      commit("setListaTrabajo", listaTrabajo);
    },

    async fetchListaTrabajoFicha({ state, commit, rootState }) {
      if (state.listaTrabajoFicha && state.listaTrabajoFicha.length > 0) {
        return;
      }

      let idFichaAgricola = rootState.fichas.fichaAgricola.idFichaAgricola;

      let idEstablecimiento =
        rootState.establecimientos.establecimiento.idEstablecimiento;
      let idTemporada = rootState.temporada.temporada?.idTemporada;
      let listaTrabajo =
        (await ActividadesRepository.listaTrabajo(
          idEstablecimiento,
          idTemporada,
          [idFichaAgricola]
        )) || [];
      commit("setListaTrabajoFicha", listaTrabajo);
    },

    clearTrabajo({ commit }) {
      commit("clearTrabajo");
    },

    clearTrabajoFicha({ commit }) {
      commit("clearTrabajoFicha");
    },
  },
};
